/**
 * SidebarMobileCollapsed Component
 *
 * Mobile-only collapsed icon sidebar with:
 * - Fixed 64px width
 * - Icon-only navigation
 * - Dark mode support
 * - Theme toggle
 *
 * @module SidebarMobileCollapsed
 */

import React from 'react';
import { IconMenu2 } from '@tabler/icons-react';
import { useSidebar } from '../hooks/useSidebar';
import NavigationItemIcon from './NavigationItemIcon';
import ThemeToggleIcon from './ThemeToggleIcon';

/**
 * SidebarMobileCollapsed Component
 *
 * Minimal icon-only sidebar for mobile devices
 */
const SidebarMobileCollapsed = () => {
  const {
    navigationAreas,
    activeNavigationArea,
    isSidebarOpen,
    handleMenuClick,
    openSidebar
  } = useSidebar();

  return (
    <aside
      className="fixed left-0 top-0 h-screen w-16 flex flex-col z-30
        glass-sidebar"
      role="navigation"
      aria-label="Mobile navigation"
    >
      {/* Logo */}
      <div className="p-2 border-b border-glass-border">
        <button
          type="button"
          onClick={openSidebar}
          className="w-11 h-11 mx-auto flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-accent"
          aria-label="Open navigation menu"
          aria-controls="mobile-sidebar-drawer"
          aria-expanded={isSidebarOpen}
        >
          <span className="w-8 h-8 bg-accent flex items-center justify-center">
            <IconMenu2 className="h-5 w-5 text-accent-foreground" aria-hidden="true" />
          </span>
        </button>
      </div>

      {/* Navigation Icons */}
      <nav className="flex-1 overflow-y-auto p-2 space-y-1" aria-label="Primary navigation">
        {navigationAreas.map((item) => (
          <NavigationItemIcon
            key={item.id}
            item={item}
            isActive={activeNavigationArea?.id === item.id}
            onClick={() => handleMenuClick(item.id, item.path)}
          />
        ))}
      </nav>

      {/* Theme Toggle Icon */}
      <div className="p-2 border-t border-glass-border">
        <ThemeToggleIcon />
      </div>
    </aside>
  );
};

export default React.memo(SidebarMobileCollapsed);
